<template>
  <div class="content">
    <el-row style="width: 94%;
    padding-top: 3%;
    margin-left: 3%;
    background-color: white;
    text-align: left;
    font-family: Calibri;
    padding-bottom:200px;">
      <el-col>
        <el-row style="padding-top: 15px;">
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          The method for detecting changes in the wheat yield variability for future climate scenarios includes the following steps (Figure 1): 1) Develop emulators for the process-based models in the GGCMs; 2) Conduct MME prediction of the global wheat yield at fine-scale spatial resolution; 3) Correct for the bias in the predicted global wheat yield using country-level reported yield to best capture the actual interannual yield variability; 4) Summarized yield risk change; Fig. 1 shows the technical flowchart for mapping climate change risk of crop yield of the world.
          <el-row style="text-align: center;">
            <img style="width: 80%;" src="http://bunjs.aiside.top/9-1.jpg"/>
            <br/>
            <span>Fig. 1 Technical flowchart for mapping climate change risk of crop yield of the world</span>
          </el-row>
        </el-row>

        <el-row class="r_title">
          Development of GGCM emulators
        </el-row>
        <el-row style="font-weight: bold; margin-top: 10px;">Training extreme gradient boosting model</el-row>
        <el-row>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;The machine-learning approach was used in this study because it is very appropriate for developing a GGCM emulator (Folberth et al. 2019). The development of the emulator consists of training a machine-learning (ML) model on specific GGCM input and output datasets so that the ML models may replicate the complex process of yield simulation within the crop model.
          <br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Variables that have been frequently reported to significantly influence wheat yield were prepared as the predicting variables (Folberth et al. 2019), and cover climate, soil type, length of vegetation period, and management practices. All the data for training were computed/adapted from the GGCMs’ input and output datasets. For climate data, the monthly variables and the growing season variables were considered. The soil properties, the length of vegetation period, and the management practices were site-specific variables.
          <br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;In total, six different emulators were trained for the three GGCMs (pDSSAT, pAPSIM, and EPIC-IIASA) each with two cultivation possibilities (rain-fed and irrigation). An extreme gradient boosting (XGB) algorithm was used due to the better performance in terms of goodness-of-fit, cross-validation errors, and computation efficiency than the random forest algorithm (Folberth et al. 2019). The predicting variables and the simulated yield in the GGCMs were randomly split into training and validation sets which contained 75% and 25% of the samples (Yue, Zhang, and Shang 2019), respectively.
        </el-row>

        <el-row style="font-weight: bold;margin-top: 20px">
          Predicting global crop yield by MME
        </el-row>
        <el-row>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          The MME yield prediction was performed at the global level for grids with a spatial resolution of 0.25° for the years 1986–2005 (baseline), 2016–2035 (2030s), and 2046–2065 (2050s) under RCPs of 4.5 and 8.5. The MME approach has been proven to be a reliable method in reproducing the main effects anticipated for climate change when simulations are compared with observation (Asseng et al. 2015; Frieler et al. 2017). The large climate-crop model emulator setup in our framework enabled a robust MME estimate as well as analysis of spatial heterogeneity and inter-model uncertainty (Martre et al. 2015). There were 315 treatments (21 GCMs × 3 emulators for the baseline, RCP4.5-2030s, RCP4.5-2050s, RCP8.5-2030s, and RCP8.5-2050s) each simulated for 20-year periods. The years after 2065 were excluded because when warming is at a high level, uncertainty across the GCMs would increase significantly (Schauberger et al. 2017). For future yield predictions, the planting dates, the soil properties, and the management practices were assumed to remain constant with time. The MME median for the yield variability across the three crop model emulators and the 21 GCMs was taken as the final estimate.
        </el-row>

        <el-row style="font-weight: bold;margin-top: 20px;">
          Bias correction of the predicted yield in the baseline and in future applications
        </el-row>
        <el-row>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          The emulator-predicted global wheat yields were corrected for bias using the national yield reports of the FAO. Rainfed and irrigated yield were first aggregated to the grid and national levels using an area-weighted average (Müller et al. 2017) as described in the following equation
        </el-row>

        <el-row class="r_content">
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;where i is the index of any grid cell assigned to the spatial unit in year t, n is the number of grid cells in that spatial unit,   is the emulator-predicted yield under fully irrigated conditions in a grid cell i, and   is the emulator-predicted yield for rain-fed conditions in a grid cell i;   refers to harvested area in grid cell i, either due to fully irrigated or rainfed, obtained from SPAM.
        </el-row>


        <el-row class="r_title">
          Measuring the yield risk
        </el-row>
        <el-row class="r_content">
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;To fully describe the yield risk, the conventional approach was to derive the probability distribution or the cumulative distribution of the yield (Coble et al. 2010; Ye et al. 2015). In this study, we computed the mean yield (multi-year average), yield interannual variability (multi-year standard deviation) and the lower yield extremes (multi-year 10th percentile) across different 20-year periods. To account for the uncertainty associated with the projected input climate data (Tao and Zhang, 2013) the computation was conducted for simulated yield series derived independently with each GCM and emulator, and the statistics of the multi-model ensemble were reported.
        </el-row>


      </el-col>
    </el-row>
  </div>
</template>

<script>
  export default {
    name: "GlobalClimateChangeRiskOfCropYield"
  }
</script>

<style scoped>

  .r_content{

  }
  .r_marginTop{
    margin-top: 15px;
  }

  .r_title{
    font-weight: bold;
    font-size: 2.5rem;
    margin-top: 30px;
  }



  .content{
    overflow-y: scroll;
    line-height: 40px;
    font-size: 2.2rem;
    color: black;
  }
  .content::-webkit-scrollbar {
    display: none;/*隐藏滚动条*/
  }
</style>



// WEBPACK FOOTER //
// src/view/BSD/About/GlobalClimateChangeRiskOfCropYield.vue